/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : TicketsFilter.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { useDispatch } from "react-redux";
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import CustomFilterTemplate from "../../../components/customComponentsV2/common/filter/CustomFilterTemplate";
import SortTemplate from "../../../components/customComponentsV2/common/Templates/SortTemplate";
import FilterTemplate from "../../../components/customComponentsV2/common/Templates/FilterTemplate";
import { useSelector } from "react-redux";
import CustomRadioButtonV2 from "../../../components/customComponentsV2/common/radioButton/CustomRadioButtonV2";
import CustomSearchFilterV2 from "../../../components/customComponentsV2/common/searchBar/CustomSearchFilterV2";
import {
  HandleApiActions,
  legalRequirements,
  userManagementApis,
} from "../../../redux/actions";
import CustomCheckBoxV2 from "../../../components/customComponentsV2/common/checkBox/CustomCheckBoxV2";
import CustomToolTip from "../../../components/infoButton/CustomToolTip";
import { componentStyle } from "../../../config/appTheme";

function TicketsFilter({ getFilterDetails, pageName = "" }) {
  const dispatch = useDispatch();
  const appMetaDetails = useSelector(
    (state) => state.settingsReducer?.metaData,
  );

  const UserDetails = useSelector((state) => state.userManagementReducer);
  const selectedProjectDetails = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  const LSDetails = useSelector((state) => state.legalRequirementsReducer);
  const selectedVariant = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );
  const [filterByStatusData, setFilterByStatusData] = useState([]);
  const [inputData, setInputData] = useState([]);

  const [selectedSortObjBeforeClick, setSelectedSortObjBeforeClick] = useState({
    sortBy: "created_at",
    sortOrder: "DESC",
  });

  const [
    selectedFilterByStatusObjBeforeClick,
    setSelectedFilterByStatusObjBeforeClick,
  ] = useState([]);

  const [userRadioValue, setUserRadioValue] = useState("req");
  const [filterUserList, setFilterUserList] = useState([]);
  const [selectedUserList, setSelectedUserList] = useState([]);
  const [legalInputList, setLegalInputLegalList] = useState([]);
  const [filterLegalList, setFilterLegalList] = useState([]);
  const [selectedLegalList, setSelectedLegalList] = useState([]);

  const radioData = [
    {
      value: "req",
      label: "Compliance Requestor",
    },
    {
      value: "rev",
      label: "Compliance Reviewer",
    },
  ];

  const handleUserSearch = useCallback((filteredData) => {
    setFilterUserList(filteredData);
  }, []);

  const handleLegalSearch = useCallback((filteredData) => {
    setFilterLegalList(filteredData);
  }, []);

  const getInputData = useCallback(() => inputData, [inputData]);

  useEffect(() => {
    let statusFilterTemp =
      appMetaDetails?.snow_ticket_status?.map((item) => {
        return {
          label: item?.key,
          value: item?.value,
        };
      }) || [];
    setFilterByStatusData(statusFilterTemp);
    if (pageName === "tickets") {
      setSelectedFilterByStatusObjBeforeClick(
        statusFilterTemp.filter((item) => Number(item.value) !== 101),
      );
    } else {
      setSelectedFilterByStatusObjBeforeClick(statusFilterTemp);
    }
  }, [appMetaDetails]);

  useEffect(() => {
    const getInputForUserBasedOnRadioValue = () => {
      if (userRadioValue === "req") {
        console.log(
          "selectedProjectDetails =",
          JSON.stringify(selectedProjectDetails),
        );
        let oem_details =
          UserDetails?.usersList?.length > 0 &&
          selectedProjectDetails?.co_owners?.length > 0
            ? UserDetails?.usersList?.filter((oem) =>
                selectedProjectDetails?.co_owners
                  ?.concat(selectedProjectDetails?.owner_details?.[0]?.user_id)
                  ?.includes(oem?.user_id),
              )
            : [];
        return oem_details?.map((item) => {
          return {
            label: `${item.fullname} - ${item.email}`,
            value: item.user_id,
            fullname: item.fullname,
            email: item.email,
          };
        });
      } else if (userRadioValue === "rev") {
        let tech_details =
          UserDetails?.usersList?.length > 0
            ? UserDetails?.usersList?.filter(
                (user) => user?.role_details?.role_type === 1,
              )
            : [];
        return tech_details?.map((item) => {
          return {
            label: `${item.fullname} - ${item.email}`,
            value: item.user_id,
            fullname: item.fullname,
            email: item.email,
          };
        });
      } else if (userRadioValue === "sup") {
        return appMetaDetails?.usersList || [];
      }
      return [];
    };

    const userData = getInputForUserBasedOnRadioValue();
    setInputData(userData);
    // setSelectedUserList(userData.map((user) => user.value));
  }, [userRadioValue, UserDetails, selectedProjectDetails, appMetaDetails]);

  useEffect(() => {
    console.log("---LSDetails---", LSDetails);
    let legalInputListTemp =
      LSDetails?.legalStandardDetails?.length > 0
        ? LSDetails?.legalStandardDetails?.map((item) => {
            return {
              label: item?.standard_number,
              value: item?.ls_id,
              ...item,
            };
          })
        : [];
    setLegalInputLegalList(legalInputListTemp);
  }, [LSDetails]);

  const getInputForUserBasedOnRadioValue = () => {
    return inputData;
  };

  useEffect(() => {
    dispatch(
      HandleApiActions({
        ...userManagementApis?.get_users_list,
        params: {
          page_size: 2000,
        },
      }),
    );
    dispatch(
      HandleApiActions({
        ...legalRequirements.get_legal_standard_details,
        params: {
          page_number: 1,
          page_size: 300,
        },
      }),
    );
  }, [dispatch]);

  return (
    <Box>
      <CustomFilterTemplate
        handleDiscard={() => {
          setSelectedSortObjBeforeClick({
            sortBy: "created_at",
            sortOrder: "DESC",
          });
          setSelectedFilterByStatusObjBeforeClick(filterByStatusData);
          setSelectedUserList([]);
          setUserRadioValue("req");
          setSelectedLegalList([]);
        }}
        handleClickApply={() => {
          getFilterDetails({
            sort_order: selectedSortObjBeforeClick.sortOrder,
            sort_column: selectedSortObjBeforeClick.sortBy,
            status: selectedFilterByStatusObjBeforeClick
              ?.map((e) => e.value)
              ?.join(","),
            ...(userRadioValue === "req" &&
              selectedUserList.length && {
                oem_users: selectedUserList.join(","),
              }),
            ...(userRadioValue === "rev" &&
              selectedUserList.length && {
                ts_users: selectedUserList.join(","),
              }),
            ...(selectedLegalList.length && {
              ls_id: selectedLegalList.join(","),
            }),
          });
        }}
        sections={[
          {
            heading: "Sorting",
            content: (
              <SortTemplate
                defaultValue={selectedSortObjBeforeClick}
                handleOnChange={(sortValue) => {
                  setSelectedSortObjBeforeClick(sortValue);
                }}
              />
            ),
          },
          {
            heading: "Filter By Status",
            content: (
              <FilterTemplate
                defaultValue={selectedFilterByStatusObjBeforeClick}
                handleOnChange={(sortValue) => {
                  setSelectedFilterByStatusObjBeforeClick(sortValue);
                }}
                data={filterByStatusData}
              />
            ),
          },
          {
            heading: "Filter By User",
            content: (
              <Box>
                <Box>
                  <CustomRadioButtonV2
                    value={userRadioValue}
                    onChange={(e) => {
                      setUserRadioValue(e.target.value);
                    }}
                    data={radioData}
                  />
                </Box>
                <Box sx={{ p: 0, mt: 1, mb: 1 }}>
                  <CustomSearchFilterV2
                    placeholder="Search"
                    searchKeys={["fullname", "email"]}
                    getDataOnSearch={handleUserSearch}
                    inputData={getInputData()}
                  />
                </Box>
                <Box
                  sx={{
                    minHeight: "290px",
                    maxHeight: "290px",
                    overflowY: "auto",
                    ...componentStyle.scroll,
                  }}
                >
                  {filterUserList?.length > 0
                    ? filterUserList?.map((item) => {
                        return (
                          <CustomToolTip title={item.label} type="component">
                            <CustomCheckBoxV2
                              label={
                                item.label.length > 20
                                  ? item.label.substring(0, 20) + "..."
                                  : item.label
                              }
                              value={selectedUserList.includes(item?.value)}
                              onChange={() => {
                                if (selectedUserList.includes(item?.value)) {
                                  setSelectedUserList(
                                    selectedUserList.filter(
                                      (id) => id !== item?.value,
                                    ),
                                  );
                                } else {
                                  setSelectedUserList([
                                    ...selectedUserList,
                                    item?.value,
                                  ]);
                                }
                              }}
                            />
                          </CustomToolTip>
                        );
                      })
                    : null}
                </Box>
              </Box>
            ),
          },
          {
            heading: "Filter By Legal",
            content: (
              <Box>
                <Box sx={{ mb: 1 }}>
                  <CustomSearchFilterV2
                    placeholder="Search"
                    searchKeys={["standard_number"]}
                    getDataOnSearch={handleLegalSearch}
                    inputData={legalInputList}
                  />
                </Box>
                <Box
                  sx={{
                    minHeight: "340px",
                    maxHeight: "340px",
                    overflowY: "auto",
                    ...componentStyle.scroll,
                  }}
                >
                  {filterLegalList?.length > 0
                    ? filterLegalList?.map((item) => {
                        return (
                          <CustomToolTip
                            title={item.label.length > 15 ? item.label : ""}
                            type="component"
                          >
                            <CustomCheckBoxV2
                              label={
                                item.label.length > 15
                                  ? item.label.substring(0, 15) + "..."
                                  : item.label
                              }
                              value={selectedLegalList.includes(item?.value)}
                              onChange={() => {
                                if (selectedLegalList.includes(item?.value)) {
                                  setSelectedLegalList(
                                    selectedLegalList.filter(
                                      (id) => id !== item?.value,
                                    ),
                                  );
                                } else {
                                  setSelectedLegalList([
                                    ...selectedLegalList,
                                    item?.value,
                                  ]);
                                }
                              }}
                            />
                          </CustomToolTip>
                        );
                      })
                    : null}
                </Box>
              </Box>
            ),
          },
        ]}
      />
    </Box>
  );
}

export default TicketsFilter;
